import { User } from 'projects/core/src/lib/login/data/user';
import { AbstractModel, JsonObject, JsonProperty } from 'projects/core/src/public-api';
import { ProjectActivity } from '../../../project-misc/data/project/activity/project-activity';
import {BacklogActivity} from './backlog-activity';

@JsonObject('model.EngineeringColumn')
export class EngineeringColumn extends AbstractModel {

    @JsonProperty(String, 'title')
    title: string;

    @JsonProperty(String, 'color')
    color: string;

    @JsonProperty([BacklogActivity], 'activities')
    activities?: BacklogActivity[];

    @JsonProperty([EngineeringColumn], 'groups')
    groups?: EngineeringColumn[];

    @JsonProperty(User, 'user')
    user?: User;

    @JsonProperty(Number, 'qty')
    qty: number;

    @JsonProperty(Number, 'statusId')
    statusId: number;

    @JsonProperty(String, 'statusName')
    statusName: string;

    parent?: EngineeringColumn;

}
